import { render, staticRenderFns } from "./IntranetIermissions.vue?vue&type=template&id=7e7648a6&scoped=true"
import script from "./IntranetIermissions.vue?vue&type=script&lang=js"
export * from "./IntranetIermissions.vue?vue&type=script&lang=js"
import style0 from "./IntranetIermissions.vue?vue&type=style&index=0&id=7e7648a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7648a6",
  null
  
)

export default component.exports